import { Link, type ToOptions } from '@tanstack/react-router'
import clsx from 'clsx'
import type React from 'react'
import type { ReactElement } from 'react'
import { themeClass } from '~/styles/theme.css'
import {
  button,
  buttonDisabled,
  buttonDisabledActive,
  buttonExtraSmall,
  buttonFullWidth,
  buttonNarrow,
  buttonShrink,
  buttonSmall,
  buttonVariants
} from './Button.css'
import { ButtonVariation } from './ButtonVariation'

export interface ButtonProps
  extends React.HTMLProps<HTMLButtonElement & HTMLAnchorElement> {
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement & HTMLAnchorElement, MouseEvent>
  ) => void
  buttonSize?: 'small' | 'extraSmall'
  fullWidth?: boolean
  disabled?: boolean
  variation?: ButtonVariation
  narrow?: boolean
  shrink?: boolean
  children: React.ReactNode
  type?: 'button' | 'reset' | 'submit' | undefined
  link?: ToOptions
  preload?: never
}

export const Button = ({
  variation = ButtonVariation.Primary,
  buttonSize,
  fullWidth = false,
  disabled = false,
  onClick = () => {},
  className,
  narrow = false,
  shrink = false,
  children,
  link,
  ...rest
}: ButtonProps): ReactElement => {
  const Tag =
    link !== undefined ? Link : rest.href !== undefined ? 'a' : 'button'
  return (
    <Tag
      className={clsx(
        themeClass,
        button,
        buttonSize === 'small' ? buttonSmall : null,
        buttonSize === 'extraSmall' ? buttonExtraSmall : null,
        narrow ? buttonNarrow : null,
        fullWidth ? buttonFullWidth : null,
        shrink ? buttonShrink : null,
        disabled
          ? variation === ButtonVariation.Primary
            ? buttonDisabledActive
            : buttonDisabled
          : buttonVariants[variation],
        className
      )}
      onClick={onClick}
      disabled={disabled}
      {...(Tag === Link ? link : {})}
      {...rest}
    >
      {children}
    </Tag>
  )
}
